import Marionette from 'backbone.marionette';

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/alert';

import ModalRegion from "./components/ModalRegion";
import AlertRegion from "./components/AlertRegion";
import EntranceModalView from "./components/EntranceModalView";
import PreferencesModalView from "./components/PreferencesModalView";
import AppModel from "./components/MemberModel";

import alertTemplate from "./templates/alert.ejs";
import SignupView from "./components/SignupView";

const AppView = Marionette.View.extend( {

   el: 'body', // Bind to body element without rendering
   template: _.noop,

   regions: {
      signup: '#signup',
      alert: {
         el: '#alert',
         regionClass: AlertRegion
      },
      modal: {
         el: '#modal',
         regionClass: ModalRegion
      }
   },

   events: {
      "click #manage-modal": function () {
         this.getRegion( 'modal' ).show( new PreferencesModalView( {model: this.model, app: this} ) );
      }
   },

   initialize: function ( options ) {
      this.mergeOptions( options, ['data'] );
      this.model = new AppModel( {}, {listId: this.data.listId} );

      this.getRegion( 'modal' ).show( new EntranceModalView( {model: this.model, app: this} ), {
         backdrop: 'static',
         keyboard: false,
         focus: false
      } );

      this.getRegion( 'signup' ).show( new SignupView( {model: this.model, app: this} ) );
   },

   showAlert: function ( cssClass, message ) {
      this.getRegion( 'alert' ).show( {
         template: alertTemplate,
         templateContext: {
            alertClass: cssClass,
            message: _.template( message, {variable: 'email'} )( this.model.get( 'email_address' ) ),
         }
      } );
   },
} );

new AppView( {data: window.data} );
